import { all, fork } from "redux-saga/effects";
import {
  getAllVideosWatcher,
  createVideoWatcher,
  updateVideoWatcher,
  deleteVideoWatcher,
} from "../videos-saga";

export default function* videosRootSaga() {
  yield all([
    fork(getAllVideosWatcher),
    fork(createVideoWatcher),
    fork(updateVideoWatcher),
    fork(deleteVideoWatcher),
  ]);
}
